import { srSpeak } from "./srSpeak";
import { focus } from "./focus";

otto.ally.assignNamespace(
  {
    srSpeak,
    focus,
  },
  { lock: import.meta.env.VITE_OTTO_IS_TESTING_BUNDLE !== "true" },
);
